import jsPDF from 'jspdf'
import { addSwimLanes } from '@/helpers/svgConvert'

export function cloneAndPrepareSvg (svgElement, workflowData) {
  const clonedSvg = svgElement.cloneNode(true)

  updateTextElements(clonedSvg)

  updateSequenceArrows(clonedSvg)

  addSwimLanes(clonedSvg, workflowData.svgLanesData, workflowData.roleDefinition.color.rgb, workflowData.hasGroups)

  removeUnwantedElements(clonedSvg)

  addCustomFont(clonedSvg)

  return clonedSvg
}

function updateTextElements (svgElement) {
  const textElements = [...svgElement.querySelectorAll('.gateway-name'), ...svgElement.querySelectorAll('.event-name')]
  textElements.forEach((textElement) => {
    const foreignObject = textElement.classList.contains('gateway-name')
      ? textElement.parentNode.parentNode
      : textElement.parentNode

    const textContent = textElement.textContent || ''
    const fontSize = textElement.style.fontSize

    const div = document.createElement('div')
    div.setAttribute('xmlns', 'http://www.w3.org/1999/xhtml')
    div.style.cssText = `
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      width: 100%;
      font-size: ${fontSize};
      text-align: center;
      font-weight: 500;
      line-height: 12px;
    `
    div.textContent = textContent

    foreignObject.parentNode.replaceChild(div, foreignObject)
  })
}

function updateSequenceArrows (svgElement) {
  const sequenceArrows = svgElement.querySelectorAll('.sequence-arrow')
  sequenceArrows.forEach((element) => {
    element.setAttribute('fill', 'none')
    element.setAttribute('stroke', '#1F2833')
    element.setAttribute('stroke-linejoin', 'round')
    element.setAttribute('stroke-linecap', 'round')
    element.setAttribute('marker-end', 'url(\'#sequenceflow-end-white-black-1r79xjtcycpwpzz6dais2xasb\')')
  })
}

function removeUnwantedElements (svgElement) {
  const elementsToRemove = [
    ...svgElement.querySelectorAll('.add-event-button'),
    ...svgElement.querySelectorAll('[width="104"][height="16"]'),
    ...svgElement.querySelectorAll('.delete-group-btn')
  ]
  elementsToRemove.forEach((element) => {
    element.parentNode.removeChild(element)
  })
}

function addCustomFont (svgElement) {
  const defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs')
  const style = document.createElementNS('http://www.w3.org/2000/svg', 'style')
  style.textContent = `
    @font-face {
      font-family: 'Inter';
      src: url('https://rsms.me/inter/font-files/Inter-Regular.woff2') format('woff2');
    }
    * {
      font-family: 'Inter', sans-serif;
    }
  `
  defs.appendChild(style)
  svgElement.prepend(defs)
}

function encodeSvg (svgStr) {
  return btoa(new TextEncoder().encode(svgStr).reduce((data, byte) => data + String.fromCharCode(byte), ''))
}

export function exportDiagramAsPdf (svgElement, workflowName) {
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')

  const interFont = new FontFace('Inter', 'url(https://rsms.me/inter/font-files/Inter-Regular.woff2)')

  interFont.load().then((loadedFont) => {
    document.fonts.add(loadedFont)

    const svgData = new XMLSerializer().serializeToString(svgElement)
    const img = new Image()

    const width = svgElement.width.baseVal.value
    const height = svgElement.height.baseVal.value

    img.onload = function () {
      canvas.width = img.width
      canvas.height = img.height

      ctx.font = 'Inter'
      ctx.drawImage(img, 0, 0)

      // eslint-disable-next-line
      const pdf = new jsPDF(width > height ? 'l' : 'p', 'pt', [width, height])
      pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 0, 0, width, height)
      pdf.save(`${workflowName}.pdf`)
    }

    img.src = 'data:image/svg+xml;base64,' + encodeSvg(svgData)
  }).catch((err) => {
    console.error('Failed to load font:', err)
  })
}
